import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "Jzbro Cloud",
    appNameGlobal: "Starparks",
    confirm: "OK",
    cancel: "Kanselahin",
    loginRegister: "Mag-log in / Mag-sign up",
    userAgreement: "Mga Tuntunin ng Serbisyo",
    privacyPolicy: "Patakaran sa Privacy",
    notBound: "Hindi nakatakda",
  },
  tabbar: {
    home: "Home",
    search: "Hanapin",
    library: "Library",
    mine: "Ako",
    badgeLogin: "Log in",
    badgeUpgrade: "Upgrade",
  },
  login: {
    navTitle: "Mag-log in",
    welcome: "Maligayang pagdating sa {brand}",
    subtitle: "Mag-log in gamit ang SMS code, o WeChat / QQ",
    subtitleGlobal: "Maglaro agad bilang guest, o mag-log in gamit ang Google",
    mobileLabel: "Telepono",
    mobilePlaceholder: "Numero ng telepono",
    codeLabel: "Code",
    codePlaceholder: "SMS code",
    getCode: "Kumuha ng code",
    resendIn: "Ipadala ulit sa {sec}s",
    agreement:
      "Awtomatikong gagawa ng account ang hindi rehistradong numero. Sa pagpapatuloy, sumasang-ayon ka sa {userAgreement} at {privacyPolicy}",
    otherMethods: "Iba pang paraan ng pag-log in",
    guest: "Magpatuloy bilang guest",
    wechat: "Mag-log in gamit ang WeChat",
    qq: "Mag-log in gamit ang QQ",
    google: "Magpatuloy gamit ang Google",
    telegram: "Magpatuloy gamit ang Telegram",
    facebook: "Magpatuloy gamit ang Facebook",
    wechatComingSoon: "Malapit nang available ang WeChat log in",
    qqComingSoon: "Malapit nang available ang QQ log in",
    googleComingSoon: "Malapit nang available ang Google log in",
    googleFailed: "Nabigo ang Google log in, pakisubukan muli",
    telegramFailed: "Nabigo ang Telegram login, pakisubukan muli",
    facebookComingSoon: "Malapit nang available ang Facebook log in",
    mobileInvalid: "Pakilagay ang tamang numero ng telepono",
    codeInvalid: "Pakilagay ang code",
    codeSent: "Naipadala na ang code",
  },
  loginPrompt: {
    defaultMessage: "Mag-log in para makita ang iyong mga laro",
  },
  settings: {
    navTitle: "Settings",
    loginPrompt: "Mag-log in para pamahalaan ang settings ng account",
    nickname: "Palayaw",
    mobile: "Telepono",
    controller: "Settings ng controller",
    controllerDesc: "Sensitivity ng mouse / kanang stick / pagpalit ng button",
    about: "Tungkol sa",
    clearCache: "I-clear ang lokal na cache",
    language: "Wika",
    editNickname: "Palitan ang palayaw",
    nicknamePlaceholder: "Bagong palayaw",
    nickEmpty: "Hindi puwedeng walang laman ang palayaw",
    nickTooLong: "16 na character lang ang palayaw",
    updated: "Na-update na",
    cacheCleared: "Na-clear na. Mag-log in muli",
    aboutTitle: "Tungkol sa {brand}",
    aboutVersion: "Web na bersyon v{version}",
    aboutBody:
      "Cloud gaming na nagbibigay-daan sa iyong maglaro ng AAA titles mismo sa iyong browser, kahit saan.\nAng lahat ng nilalaman ng laro ay pag-aari ng kani-kanilang publisher.",
  },
  subscription: {
    choosePlan: "Pumili ng plano",
    included: "Kasama rito",
    orderSummary: "Buod ng order",
    total: "Kabuuan",
    continue: "Magpatuloy",
    secureNote: "Ligtas na pagbabayad · Isang beses na bili",
    navTitle: "Upgrade",
    unlockTitle: "I-unlock ang mga perk ng member",
    expired: "Nag-expire na",
    daysLeft: "{days} araw na lang",
    validUntil: "Balido hanggang {time}",
    tagline: "Walang pila, mas mahabang oras, mas mataas na kalidad",
    perDay: "Halos {price}/araw",
    recommended: "Pinakasulit",
    currentLevel: "Kasalukuyang plano",
    footer:
      "Isang beses na membership pass ito. Idaragdag ang napiling tagal kapag nakumpirma ang bayad at hindi ito awtomatikong magre-renew.",
    planVipMonth: "VIP Buwanan",
    planSvipMonth: "SVIP Buwanan",
    perkNoQueue: "Laktawan ang pila",
    perkDailyFree: "60 minutong libre araw-araw",
    perkHd: "HD na kalidad",
    perkAllVip: "Lahat ng perk ng VIP",
    perkUnlimited: "Walang limitasyong oras ng laro",
    perk4k: "4K / 60fps",
    perkSupport: "Priority na suporta",
    cnPayComingSoon:
      "Malapit nang available ang WeChat / Alipay checkout sa web — gamitin muna ang app",
    intlPayComingSoon: "Malapit nang available ang Stripe / PayPal checkout",
    payProcessing: "Kumpletuhin ang bayad at panatilihing bukas ang pahinang ito…",
    paySuccess: "Matagumpay ang bayad — na-activate na ang membership",
    payFailed: "Nabigo ang bayad, pakisubukan muli",
    payCancelled: "Kinansela ang bayad",
    telegramExtraTimeUnavailable: "Magiging available ang pagbili ng play time sa Telegram kapag naidagdag na ang Stars version.",
    payUnconfirmed:
      "Hindi pa nakumpirma ang bayad; kung nakapagbayad ka na, makikredit ito maya-maya",
    payPopupBlocked:
      "Na-block ang payment window — pahintulutan ang mga pop-up at subukan muli",
    loadPlansFailed: "Nabigong i-load ang mga plano, pakisubukan muli",
    retry: "Subukan muli",
  },
  download: {
    nav: "Download App",
    title: "Get the Starparks app",
    subtitle: "Play Starparks on your phone and purchase membership in the app.",
    androidDescription: "The Android app is available on Google Play.",
    googlePlay: "Get it on Google Play",
    iosDescription: "The iOS app is on its way.",
    comingSoon: "Coming soon",
    membershipUnavailable: "Membership is not available yet",
    membershipAppHint: "Membership purchases are not available on this website. Please use the app to purchase a membership.",
    goToDownload: "Go to download page",
  },
  app: {
    backToDesktop: "Balik sa desktop",
  },
  titles: {
    download: "Download App",
    home: "Home",
    search: "Hanapin",
    detail: "Detalye ng laro",
    library: "Library",
    category: "Kategorya",
    mine: "Ako",
    myGames: "Aking mga laro",
    reviews: "Mga review",
    gameVideos: "Mga gameplay video",
    commentReplies: "Komento",
    saves: "Mga save",
    subscription: "Upgrade",
    signIn: "Araw-araw na check-in",
    settings: "Settings",
    controlSettings: "Settings ng controller",
    login: "Mag-log in",
    play: "Naglalaro",
  },
  home: {
    searchPlaceholder: "Maghanap ng laro",
    sectionDefault: "Mga laro",
    allGames: "Lahat ng laro",
    more: "Higit pa",
    empty: "Wala pang laman dito",
    latestOnline: "Mga bagong labas",
    comingSoon: "Malapit nang ilabas",
    subscribe: "Abisuhan ako",
    subscribed: "Naka-subscribe na",
    score: "Rating",
    subscribeSuccess: "Nai-reserve na — aabisuhan ka namin kapag nailunsad",
  },
  nav: {
    home: "Home",
    library: "Library",
    searchPlaceholder: "Maghanap ng laro",
    me: "Ako",
    guest: "Guest",
    profile: "Profile",
    myGames: "Aking mga laro",
    dailyCheckIn: "Araw-araw na check-in",
    renewMembership: "I-renew ang membership",
    upgradeMembership: "I-upgrade ang membership",
    settings: "Settings",
    switchToMobile: "Lumipat sa mobile",
    logout: "Mag-log out",
    logoutConfirm: "Sigurado ka bang mag-log out?",
    mobileVersion: "Mobile",
    login: "Mag-log in",
  },
  library: {
    all: "Lahat",
    noMore: "Wala nang iba",
    loading: "Naglo-load…",
    noData: "Walang data",
    noGames: "Walang laro",
    noUpcoming: "Walang paparating na laro",
    emptyCategory: "Walang laro sa kategoryang ito",
  },
  mine: {
    notLoggedIn: "Hindi naka-log in",
    loginSyncTip: "Mag-log in para i-sync ang membership, paborito at history ng laro",
    loginSyncTipDesktop:
      "Mag-log in para makita ang profile, membership, check-in at history ng laro",
    guest: "Guest",
    daysLeft: "{n} araw na lang",
    expired: "Nag-expire na",
    renewBanner: "Mag-e-expire ang {level} mo sa {n} araw — mag-renew para sa 30% na diskwento",
    membershipExpiredRenew: "Nag-expire na ang iyong membership — mag-renew na",
    membershipExpired: "Nag-expire na ang membership",
    membershipDaysLeft: "{n} araw na lang ang membership",
    gameTime: "Oras ng laro",
    minUnit: "min",
    dailyCheckIn: "Araw-araw na check-in",
    upgrade: "Upgrade",
    renew: "Renew",
    upgradeMembership: "I-upgrade ang membership",
    renewMembership: "I-renew ang membership",
    membership: "Membership",
    myCollection: "Aking paborito",
    collectedGames: "Mga naka-save na laro",
    recentlyPlayed: "Kamakailang nilaro",
    gameHistory: "History ng laro",
    settings: "Settings",
    switchToDesktop: "Lumipat sa desktop",
    accountAndPrefs: "Account at preferences",
    claimGameTime: "Kumita ng oras ng laro",
    bindPhone: "I-bind ang telepono",
    bindPhoneDesc: "Mag-upgrade sa ganap na account at mag-sync sa lahat ng device",
    bindPhoneDescDesktop: "Mag-upgrade sa ganap na account, mag-sync sa mga device",
    resetGuest: "I-reset ang guest identity",
    resetGuestDesc: "I-clear ang guest account na ito at magsimula muli",
    resetGuestDescDesktop: "Magsimula muli gamit ang bagong identity",
    logout: "Mag-log out",
    myGamesTitle: "Aking mga laro",
    collectTab: "Paborito",
    loginViewCollect: "Mag-log in para makita ang naka-save na laro",
    noCollect: "Wala pang naka-save na laro",
    loginViewHistory: "Mag-log in para makita ang history ng laro",
    noHistory: "Wala pang kamakailang nilaro",
    weekMon: "Lun",
    weekTue: "Mar",
    weekWed: "Miy",
    weekThu: "Huw",
    weekFri: "Biy",
    weekSat: "Sab",
    weekSun: "Lin",
    alreadySignedToday: "Naka-check-in ka na ngayong araw",
    signSuccessReward: "Naka-check-in! +{n} min",
    signSuccess: "Naka-check-in",
    loginJoinCheckIn: "Mag-log in para sumali sa araw-araw na check-in",
    claimed: "Nakuha na",
    unclaimed: "Nalaktawan",
    todayDone: "Ngayon ✓",
    today: "Ngayon",
    dayN: "Araw {n}",
    signedToday: "Naka-check-in na ngayong araw",
    signNow: "Mag-check-in ngayon",
    checkInTip1: "Mag-check-in araw-araw para kumita ng libreng oras ng laro.",
    checkInTip2: "Puwedeng i-make-up ang mga nalaktawang araw gamit ang coins sa make-up page.",
    loggedOut: "Naka-log out na",
    resetGuestConfirm:
      "Buburahin nito ang kasalukuyang guest account at magsisimula muli gamit ang bagong identity. Mawawala lahat ng nabiling subscription, paborito at history. Magpatuloy?",
    resetGuestConfirmBtn: "I-reset",
    resetting: "Nire-reset…",
    resetDone: "Tapos na ang reset — mangyaring mag-log in muli",
  },
  reviews: {
    recommendRate: "rekomendado",
    tooFew: "Kakaunti pa ang review",
    count: "{n} review",
    playFirst: "Laruin muna para makapag-review",
    rateThis: "Nalaro na? Mag-review",
    mine: "Akin",
    edit: "I-edit",
    delete: "Burahin",
    report: "I-report",
    played: "Nilaro {d}",
    contentEmpty: "Hindi pwedeng walang laman ang review",
    editReview: "I-edit ang review",
    editDone: "Na-update",
    published: "Na-post ang review",
    deleteTitle: "Burahin ang review?",
    deleteConfirm: "Hindi na ito maibabalik. Burahin ang review na ito?",
    deleted: "Nabura",
    reportTitle: "I-report",
    reportConfirm: "I-report ang nilalamang ito? Susuriin ito ng aming team.",
    reported: "Na-report",
    deleteReplyTitle: "Burahin ang reply?",
    deleteReplyConfirm: "Burahin ang reply na ito?",
    replyTo: "tumugon kay",
    viewAllReplies: "Tingnan lahat ng {n} reply",
    loadMore: "Mag-load pa",
    allReplies: "Lahat ng reply ({n})",
    commentDeleted: "Nabura na ang review na ito",
    commentShielded: "Itinago ang review na ito",
    replyDeleted: "Nabura na ang reply na ito",
    replyShielded: "Itinago ang reply na ito",
  },
  detail: {
    svipRequiredMsg: "Kailangan ng SVIP para malaro ang larong ito",
    timeInsufficientMsg: "Kulang ang oras ng laro. Paki-bili muna ng oras ng laro.",
    goBuy: "Bumili ngayon",
    thinkAgain: "Pag-isipan ulit",
    navTitle: "Detalye ng laro",
    back: "Bumalik",
    svipOnly: "SVIP lang",
    vipOnly: "VIP lang",
    freeMinutes: "{n} min libre",
    saveManage: "Mga save",
    saveManageDesc: "Tingnan / ibalik ang mga nakaraang save at magdagdag ng note",
    liveVideos: "Mga gameplay video",
    more: "Higit pa",
    viewAll: "Tingnan lahat",
    viewAllCount: "Tingnan lahat ng {n}",
    intro: "Tungkol sa larong ito",
    screenshots: "Mga screenshot",
    controlMethod: "Kontrol: ",
    playerReviews: "Mga review",
    commentCount: "{n}",
    recommend: "Inirerekomenda",
    notRecommend: "Hindi inirerekomenda",
    similarGames: "Magkakahawig na laro",
    collect: "Paborito",
    collected: "Naka-paborito",
    collectStar: "☆ Paborito",
    collectedStar: "★ Naka-paborito",
    unfavorited: "Inalis sa paborito",
    entering: "Pumapasok…",
    unlockSvip: "I-unlock gamit ang SVIP",
    unlockVip: "I-unlock gamit ang VIP",
    startGame: "Maglaro",
    reviewCount: "{n} review",
    sortHot: "Sikat",
    sortNew: "Pinakabago",
    noMore: "Wala nang iba",
    playedHours: "Nilaro nang {n} oras",
    report: "I-report",
    reportTitle: "I-report ang komentong ito?",
    reportMessage: "Susuriin ito ng aming mga moderator. I-report?",
    reported: "Na-report na",
    noReviews: "Wala pang review — maging una",
    writeReview: "Magsulat ng review",
    reviewPlaceholder: "Ibahagi ang iyong karanasan… (5 character pataas)",
    reviewMinLength: "Dapat 5 character pataas ang review",
    reviewSubmitted: "Naisumite na ang review",
    publish: "I-publish",
    commentDetail: "Komento",
    replyCount: "{n} reply",
    noReplies: "Wala pang reply — maging una",
    reply: "Sumagot",
    replyToUser: "Sumagot kay {'@'}{name}",
    saySomething: "Magsabi ng kahit ano…",
    send: "Ipadala",
    sent: "Naipadala na",
    videoCount: "{n} video",
    watchCount: "{k}k views",
    noVideos: "Wala pang video",
    videoUnavailable: "Hindi mai-play ang video na ito sa ngayon",
    videoUnavailableDesc: "Maaaring lumang clip na tinanggal na — sumubok ng iba",
  },
  search: {
    placeholder: "Ilagay ang pangalan ng laro",
    emptyHint: "Maghanap ayon sa pangalan ng laro o pinyin",
    history: "Kamakailang hinanap",
    clear: "I-clear",
    noResults: "Walang nahanap na laro",
  },
  misc: {
    savesTitle: "Mga Save ng Laro",
    savesTitleNamed: "{name} - Mga save",
    savesLoginPrompt: "Mag-log in para makita ang mga save ng laro",
    savesActiveHeading: "Aktibong save",
    savesUnnamed: "Walang pangalang save",
    savesEditRemark: "Palitan ang pangalan",
    savesEmpty: "Wala pang cloud save",
    savesEmptyHint: "Awtomatikong magsi-sync dito ang mga save na ginawa sa laro",
    savesHistory: "History",
    savesCount: "{n} save",
    savesCurrent: "Kasalukuyan",
    savesCorrupted: "Sira",
    savesRestore: "Ibalik",
    savesNoHistory: "Walang history ng save",
    savesFooter:
      "Nagagawa ang mga save sa pamamagitan ng manual / auto save sa laro at awtomatikong nagsi-sync sa cloud. Hindi pa suportado ang manu-manong pagtanggal sa ngayon (kapag patuloy kang nag-save sa laro, mapapalitan ang pinakaluma).",
    savesRemarkTitle: "I-edit ang remark ng save",
    savesRemarkPlaceholder: "Pangalanan ang save na ito, hal. \"Natapos ang Chapter 1\"",
    savesSave: "I-save",
    savesAlreadyCurrent: "Ito na ang kasalukuyang save",
    savesRestoreTitle: "Ibalik ang save",
    savesRestoreConfirm:
      "Ibalik sa save na ito? Sa susunod na paglunsad, magsisimula ang laro mula sa \"{name}\".",
    savesSwitched: "Lumipat na sa save na ito",
    savesSaved: "Na-save na",
    ctrlNavTitle: "Settings ng Controller",
    ctrlSave: "I-save",
    ctrlIntro:
      "I-adjust dito ang pakiramdam ng mouse / gamepad. Ang anumang value na blangko / 0 ay susunod sa server default ng bawat laro; may bisa ang pagbabago sa lahat ng laro.",
    ctrlMouseSensitivity: "Sensitivity ng mouse",
    ctrlServerDefault: "Server default",
    ctrlMouseHint: "Sa locked mode, distansya ng galaw = pisikal na galaw × {n}%",
    ctrlStickSensitivity: "Sensitivity ng kanang stick",
    ctrlStickHint:
      "Bilis ng pag-ikot ng aim para sa FPS / action games. Hindi apektado ang kaliwang stick (galaw).",
    ctrlPrimaryClick: "Pangunahing button ng mouse",
    ctrlLeftPrimary: "Kaliwa ang pangunahin",
    ctrlRightPrimary: "Kanan ang pangunahin",
    ctrlPrimaryClickHint:
      "Ilang laro (hal. ilang indie titles) ang nagpapaputok gamit ang right-click bilang default at kailangang palitan.",
    ctrlResetDefault: "I-reset",
    ctrlSavedToast: "Na-save na, nalalapat sa susunod na paglunsad",
    ctrlResetToast: "Naibalik sa config ng server",
    savesUploading: "Ina-upload ang save — subukan muli mamaya",
    savesCheckFailed: "Hindi masuri ang status ng save — subukang muli",
  },
  play: {
    stageReady: "Handa na",
    queueing: "Nasa pila",
    queueJoining: "Sumasali sa pila…",
    queueAheadPrefix: "",
    queueAheadSuffix: "na manlalaro ang nauna sa iyo",
    queueEta: "mga {n}s",
    cancelReturn: "Kanselahin at bumalik",
    back: "Bumalik",
    retry: "Subukan muli",
    goSubscribe: "Upgrade",
    entering: "Pumapasok sa laro",
    vipCta: "Mag-upgrade sa VIP para makapasok agad",
    vipPerks: "Walang pila + HD na kalidad + mas mahabang oras",
    sessionExpiredHint:
      "Karaniwang nag-e-expire ang session matapos ang mahabang paghihintay — i-tap ang \"Subukan muli\" para pumila ulit",
    lineOldUser: "Pila ng bumabalik na manlalaro",
    lineNewbie: "Pila ng bagong manlalaro",
    lineFast: "Fast-track na pila",
    lineSvip: "Pila ng SVIP",
    svipRequired: "SVIP lang ang larong ito. Mag-upgrade muna sa SVIP",
    stageConnectingServer: "Kumokonekta sa server…",
    stageHandshake: "Nakikipag-handshake sa server…",
    stageP2pNegotiating: "Inaayos ang P2P channel…",
    stageMediaStreaming: "Nagsa-stream ng media…",
    stageWaitingFrame: "Naghihintay ng video…",
    stageVideoTrack: "Natanggap na ang video track…",
    stageEntered: "Nakakonekta na",
    stageConnect: "Koneksyon",
    stageConnectedSoon: "Nakakonekta na — malapit nang lumitaw ang video…",
    allocFailed: "Hindi makapag-allocate ng game server",
    allocFailedHttp: "Nabigo ang allocation (HTTP {status})",
    reenterHint: " (pakilabas at pumasok muli sa laro)",
    errP2pFailed: "Nabigo ang P2P negotiation. Pakisuri ang iyong network",
    errDisconnected: "Nawala ang koneksyon (code={code}). Pakisubukan muli",
    errStageFailed: "Nabigo ang {stage}",
    errStageFailedDetail: "Nabigo ang {stage}: {detail}",
    errConnectTimeout:
      "Nag-timeout ang koneksyon — hindi maabot ang server. Pakisuri ang network at subukan muli",
    errQueueCancelled: "Kinansela ng server ang iyong pila. Pakisubukan muli",
    errKicked:
      "Naka-log in ang iyong account sa ibang device, kaya na-disconnect ang session na ito",
    errCannotStart: "Hindi masimulan ang laro sa ngayon",
    registerFailed: "Nabigo ang pagrehistro",
  },
  game: {
    recharge: "Mag-top up",
    tabControl: "Kontrol",
    tabFrame: "Display",
    tabVoice: "Tunog",
    controlScheme: "Control mode",
    hideVirtualKeys: "Itago ang virtual keys",
    mouseMode: "Mouse mode",
    mouseModeTouchpad: "Touchpad",
    mouseModeDrag: "Drag",
    mouseModeDirect: "Direkta",
    mouseSensitivity: "Sensitivity ng mouse {n}%",
    rightStickMode: "Mode ng kanang stick",
    joyModeFixed: "Nakapirmi",
    joyModeHalf: "Kalahating screen",
    joyModeFull: "Buong screen",
    joyModeDrag: "Drag",
    stickSensitivity: "Sensitivity ng stick {n}%",
    customLayout: "Custom na key layout",
    editLayout: "I-edit ang layout",
    frameComingSoon:
      "Darating sa susunod na bersyon ang display scaling / pagpapalit ng kalidad.",
    gameSound: "Tunog ng laro",
    schemeFollow: "Sundin ang laro",
    schemeGamepad: "Gamepad",
    schemeKeyMouse: "Keyboard at mouse",
    schemeTouch: "Touch",
    schemeSwitchedGamepad: "Lumipat sa gamepad",
    schemeSwitchedKeyMouse: "Lumipat sa keyboard at mouse",
    schemeSwitchedFollow: "Naibalik sa pagsunod sa laro",
    modifierTitle: "Mga modifier",
    modifierNeedUnlock: "Kailangang bilhin ang modifier na ito para ma-unlock",
    usageTitle: "Mga tagubilin",
    usageEmpty: "Wala pang tagubilin",
    gotIt: "Sige",
    close: "Isara",
    noModifiers: "Walang modifier",
    locked: "Naka-lock",
    needUnlock: "Bilhin para ma-unlock",
    remaining: "{d} na lang",
    use: "Gamitin",
    quitTitle: "Lumabas sa laro",
    quitConfirm: "Lumabas sa kasalukuyang laro?",
    quitConfirmBtn: "Lumabas",
    quitCancelBtn: "Magpatuloy sa laro",
    joyNameFixed: "Nakapirmi",
    joyNameHalfZone: "Kalahating-screen na zone",
    joyNameFullFollow: "Buong-screen na pagsunod",
    joyNameDrag: "Drag",
    padConnected: "🎮 Nakakonekta ang gamepad, nakatago ang virtual keys",
    padDisconnected: "Na-disconnect ang gamepad, naibalik ang virtual keys",
    rightStickToast: "Kanang stick: {name}",
    noEditableLayout: "Walang ma-edit na key layout",
    timeUsedUp: "Naubos na ang oras ng laro",
    addTimeSuccess: "Nadagdagan ang oras",
    submitted: "Naisumite na",
    minutesShort: "{n} min",
    addTime: "Magdagdag ng oras",
    expand: "Palawakin",
    collapse: "I-collapse",
    physicalPadConnected: "Nakakonekta ang pisikal na gamepad",
    unmute: "I-unmute",
    mute: "I-mute",
    fullscreen: "Fullscreen",
    summonKeyboard: "Ipakita ang keyboard",
    sensoryMode: "Motion controls",
    idleWarnTip: "Walang aktibidad. Lalabas sa laro sa {n}s.",
    idleContinue: "Magpatuloy",
    nsInputTitle: "Kailangan ng laro ng text input",
    nsInputHint: "Mag-type ng text, tapos kumpirmahin",
    settings: "Settings",
    currentRemaining: "{n} minuto na lang",
    exchangeBeans: "Ipalit ang beans sa oras",
    useAddTimeCard: "Gamitin ang add-time card",
  },
  drama: {
    title: "Maiikling Drama", refresh: "I-refresh", retry: "Subukan muli", loadFailed: "Hindi ma-load ang mga drama.", completed: "Tapos", episodes: "{n} episode", noMore: "Wala nang iba", loadMore: "Mag-load pa", back: "Bumalik", episode: "Episode {n}", episodesLabel: "Mga episode", lockedTitle: "I-unlock ang episode", lockedBody: "I-unlock sa host app o manood ng rewarded ad.", unlockEpisode: "I-unlock", watchAd: "Manood ng ad", adUnlocked: "Na-unlock ang episode", adUnavailable: "Walang available na ad.", paymentPending: "Tapusin ang bayad sa host app.", paymentUnavailable: "Hindi available ang bayad.", videoUnavailable: "Hindi available ang video.",
  },
  net: {
    requestFailed: "Nabigo ang kahilingan",
    errorWithCode: "Error {code}",
    serverError: "Error sa server {status}",
    timeout: "Nag-timeout ang kahilingan",
    networkError: "Error sa network",
  },
  controls: {
    selectKeyFirst: "Pumili muna ng button",
    saved: "Na-save na",
    saveFailed: "Nabigo ang pag-save",
    selected: "Napili: {name}",
    keyFallback: "button",
    hint: "I-drag para ilipat; i-tap para i-adjust ang laki / opacity / action",
    size: "Laki {pct}%",
    opacity: "Opacity {pct}%",
    operation: "Action",
    opPress: "Pindutin",
    opDrag: "Drag",
    opLock: "I-lock",
    delete: "Burahin",
    addKey: "Magdagdag ng button",
    reset: "I-reset",
    save: "I-save",
    addHiddenKey: "Magdagdag ng nakatagong button",
    noHiddenKeys: "Walang nakatagong button",
  },
};

export default messages;
